import CourseClassHeaderNavigation from '../../components/CourseClassHeaderNavigation/CourseClassHeaderNavigation'
import { useConfigContext } from '../../contexts/ConfigContext/ConfigContextProvider';
import OwnCoursesList from '../../features/OwnCourses/OwnCoursesList/OwnCoursesList'
import MainLayout from '../../layouts/MainLayout/MainLayout'
import './OwnCourses.css'

export default function OwnCourses() {
   
   const { jsonTexts } = useConfigContext();
   const texts = jsonTexts?.misCursos

   return (
      <MainLayout>
         <section className='OwnCourses-container'>

            <CourseClassHeaderNavigation noButton title={texts.title} />

            < OwnCoursesList />

         </section>
      </MainLayout>
   )
}
